import React, { Component } from "react";
import "./ResetPassword.scss";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { resetPassword } from "../../../actions/authAction";
import { Redirect } from "react-router-dom";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
import { ReactComponent as EyeClose } from "../../../assets/svg/password-hide.svg";
import { ReactComponent as EyeOpen } from "../../../assets/svg/password-show.svg";
import { ReactComponent as ResetPasswordImage } from "../../../assets/svg/password-reset.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import SocialLogin from "../SocialLogin/SocialLogin";
import { isMobile } from "react-device-detect";
// import SocialLogin from "../SocialLogin/SocialLogin";

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newPassword: "",
            confirmPassword: "",
            showNewPassword: false,
            showConfirmPassword: false,
        };
    }

    componentDidUpdate() {
        document.title = "Radarr | Reset Password";
    }

    onSubmit = () => {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#%&*])(?=.{8,})/;
        const specialCharacter = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
        const _url = window.location;
        const accessToken = new URLSearchParams(_url.search).get("access-token");
        const newPassword = this.state.newPassword;
        const confirmPassword = this.state.confirmPassword;
        if (newPassword === "") {
            toast.error("Please enter your new password.");
            return undefined;
        } else if (confirmPassword === "") {
            toast.error("Please enter confirm password.");
            return undefined;
        } else if (newPassword.length < 8) {
            toast.error("Password criteria is not fullfilled");
        } else if (newPassword.length > 30) {
            toast.error("Password criteria is not fullfilled");
        } else if (!specialCharacter.test(newPassword)) {
            toast.error("Password criteria is not fullfilled");
            return;
        } else if (newPassword !== confirmPassword) {
            toast.error("Passwords do not match.");
            return;
        } else {
            let param = {};
            param["password"] = newPassword;
            param["repeat_password"] = confirmPassword;
            param["token"] = accessToken;
            this.props.resetPassword(param).then(() => {
                this.setState({
                    newPassword: "",
                    confirmPassword: "",
                });
            });
        }
    };
    onLogin = () => {
        this.props.history.push("/signin");
    };
    setNewPassword = (newPassword) => {
        this.setState({ newPassword });
    };
    showNewPassword = () => {
        this.setState({ showNewPassword: !this.state.showNewPassword });
    };
    showConfirmPassword = () => {
        this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
    };
    setConfirmPassword = (confirmPassword) => {
        this.setState({ confirmPassword });
    };

    render() {
        let resetPasswordflag = this.props.resetPasswordflag;
        return (
            <div className="resetpass">
                {!resetPasswordflag && (
                    <>
                        <div className="reset__form">
                            <h2 className="header__text">Reset Your Password</h2>
                            <label className="block__separator">New Password*</label>
                            <div className="password__field-wrap">
                                <Popup
                                    trigger={
                                        <input
                                            autoComplete="none"
                                            placeholder="Enter new password"
                                            type={this.state.showNewPassword ? "text " : "password"}
                                            className="password__inputField"
                                            onChange={(ev) => {
                                                this.setNewPassword(ev.target.value);
                                            }}
                                        />
                                    }
                                    header="Password hint"
                                    content="Between 8 and 30 characters in length.
                                    Use at least a special character  (EG -!#$%&'()*+,-./:;<=>?@[\]^_`{|}~).
                                    Should be different from your email id and username.
                                    Should be different from your old password."
                                    position={isMobile ? "top center" : "left center"}
                                    on="focus"
                                    inverted
                                />
                                <span className="eye__btn" onClick={() => this.showNewPassword()}>
                                    {this.state.showNewPassword ? (
                                        <EyeOpen className="eye__icon" title="Hide Password" />
                                    ) : (
                                        <EyeClose className="eye__icon" title="Show Password" />
                                    )}
                                </span>
                            </div>
                            <label className="block__separator">Confirm Password*</label>
                            <div className="password__field-wrap">
                                <Popup
                                    trigger={
                                        <input
                                            autoComplete="none"
                                            placeholder="Confirm your password"
                                            type={this.state.showConfirmPassword ? "text " : "password"}
                                            className="password__inputField"
                                            onChange={(ev) => {
                                                this.setConfirmPassword(ev.target.value);
                                            }}
                                        />
                                    }
                                    header="Password hint"
                                    content="Between 8 and 30 characters in length.
                                    Use at least a special character  (EG -!#$%&'()*+,-./:;<=>?@[\]^_`{|}~).
                                    Should be different from your email id and username.
                                    Should be different from your old password."
                                    position={isMobile ? "top center" : "left center"}
                                    on="focus"
                                    inverted
                                />
                                <span className="eye__btn" onClick={() => this.showConfirmPassword()}>
                                    {this.state.showConfirmPassword ? (
                                        <EyeOpen className="eye__icon" title="Hide Password" />
                                    ) : (
                                        <EyeClose className="eye__icon" title="Show Password" />
                                    )}
                                </span>
                            </div>
                            <button
                                className="reset__btn"
                                onClick={() => {
                                    this.onSubmit();
                                }}>
                                <span>{!this.props.resetPasswordLoading ? "Submit" : <Loader inverted active size="small" />}</span>
                            </button>
                        </div>

                        <div className="route__btn">
                            <span className="signup__text">
                                Back to{" "}
                                <Link to="/signin" className="signin__text">
                                    Sign In
                                </Link>
                            </span>
                        </div>
                        {/* <div className="socialLogin__wrapper">
                            <SocialLogin routeTo={"/signin"} />
                        </div> */}
                    </>
                )}
                {resetPasswordflag && (
                    <div className="reset__pass-info">
                        <h2>Successful password reset!</h2>
                        <ResetPasswordImage />
                        <p>You can now use your password to sign in to your account</p>
                        <button className="reset__btn reset-width" onClick={() => this.onLogin()}>
                            Sign In
                        </button>
                    </div>
                )}
                <SocialLogin routeTo={"/signup"} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        resetPasswordflag: state.authReducer.resetPassword1,
        resetPasswordLoading: state.authReducer.resetPasswordLoading,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        resetPassword: (data) => dispatch(resetPassword(data)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
